var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "hheader", class: { "not-big3": !_vm.isBig3Coupon } },
    [
      _vm.isDebug
        ? [
            _vm._v("\n    MARKETS HEADER "),
            _c("br"),
            _vm._v("\n    isBig3Coupon " + _vm._s(_vm.isBig3Coupon) + " "),
            _c("br"),
            _vm._v("\n    hasDraw " + _vm._s(_vm.hasDraw)),
            _c("br"),
            _vm._v(
              "\n    maxNoOfSelections " +
                _vm._s(_vm.maxNoOfSelections) +
                "\n  "
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("section", { staticClass: "head" }, [
        _c(
          "h4",
          [
            _c("icon", {
              attrs: {
                colorName: "white",
                name:
                  "icon-" +
                  ((_vm.idfosporttype && _vm.idfosporttype.replace(/ /g, "")) ||
                    "empty")
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "coupontitle" }, [
              _vm._v(_vm._s(_vm.coupontitle))
            ]),
            _vm._v(" "),
            _c("sgp-tag", {
              attrs: {
                markets: _vm.markets,
                isLive: _vm.isLiveEventPage,
                isForCoupon: "Big3"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isBig3Coupon
        ? [
            _c(
              "section",
              {
                staticClass: "big3-markets-header layout",
                class: { "big3-column-order": _vm.big3ColumOrderEnabled }
              },
              [
                _c(
                  "div",
                  {
                    class: [
                      "markets-title",
                      { "available-for-bb": _vm.isPointsMarketAvailableForBB },
                      _vm.big3PointsSpreadOrder
                    ]
                  },
                  [
                    _vm.isPointsMarketAvailableForBB
                      ? _c("span", { staticClass: "available-for-bb" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h4", { staticClass: "big3-market-name" }, [
                      _vm._v(_vm._s(_vm.$t("MarketsHeader.MarketName.Spread")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      "markets-title",
                      { "available-for-bb": _vm.isMoneyMarketAvailableForBB },
                      _vm.big3MoneyLineOrder
                    ]
                  },
                  [
                    _vm.isMoneyMarketAvailableForBB
                      ? _c("span", { staticClass: "available-for-bb" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h4", { staticClass: "big3-market-name" }, [
                      _vm._v(_vm._s(_vm.$t("MarketsHeader.MarketName.Money")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    class: [
                      "markets-title",
                      { "available-for-bb": _vm.isTotalMarketAvailableForBB },
                      _vm.big3TotalPointsOrder
                    ]
                  },
                  [
                    _vm.isTotalMarketAvailableForBB
                      ? _c("span", { staticClass: "available-for-bb" })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("h4", { staticClass: "big3-market-name" }, [
                      _vm._v(_vm._s(_vm.$t("MarketsHeader.MarketName.Total")))
                    ])
                  ]
                ),
                _vm._v(" "),
                !_vm.mobileBigAndBelow &&
                _vm.brandLayout !== "generic" &&
                _vm.brandKey !== "sb" &&
                _vm.brandKey !== "mav" &&
                _vm.brandKey !== "qcasino" &&
                _vm.brandKey !== "pr"
                  ? _c("span", { staticClass: "more_bets" }, [
                      _vm._v(_vm._s(_vm.$t("MarketsHeader.MoreBets")))
                    ])
                  : _vm._e()
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isBig3Coupon
        ? [
            _vm.hasDraw && _vm.maxNoOfSelections <= 3
              ? _c(
                  "section",
                  { staticClass: "markets-header layout no-draw" },
                  [
                    _c("div", { staticClass: "markets-title" }, [
                      _c("h4", { staticClass: "big3-market-name" }, [
                        _vm._v(_vm._s(_vm.$t("MarketsHeader.MarketName.Home")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "markets-title" }, [
                      _c("h4", { staticClass: "big3-market-name" }, [
                        _vm._v(_vm._s(_vm.$t("MarketsHeader.MarketName.Tie")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "markets-title" }, [
                      _c("h4", { staticClass: "big3-market-name" }, [
                        _vm._v(_vm._s(_vm.$t("MarketsHeader.MarketName.Away")))
                      ])
                    ]),
                    _vm._v(" "),
                    !_vm.mobileBigAndBelow &&
                    _vm.brandLayout !== "generic" &&
                    _vm.brandKey !== "sb" &&
                    _vm.brandKey !== "mav" &&
                    _vm.brandKey !== "qcasino" &&
                    _vm.brandKey !== "pr"
                      ? _c("span", { staticClass: "more_bets" }, [
                          _vm._v(_vm._s(_vm.$t("MarketsHeader.MoreBets")))
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.hasDraw &&
            _vm.maxNoOfSelections <= 3 &&
            ["GOLF", "MOTORSPORT"].indexOf(_vm.idfosporttype) === -1 &&
            !_vm.isoutright
              ? _c("section", { staticClass: "markets-header layout" }, [
                  _c("div", { staticClass: "markets-title" }, [
                    _c("h4", { staticClass: "big3-market-name" }, [
                      _vm._v(_vm._s(_vm.$t("MarketsHeader.MarketName.Winner")))
                    ])
                  ]),
                  _vm._v(" "),
                  !_vm.mobileBigAndBelow &&
                  _vm.brandLayout !== "generic" &&
                  _vm.brandKey !== "sb" &&
                  _vm.brandKey !== "mav" &&
                  _vm.brandKey !== "qcasino" &&
                  _vm.brandKey !== "pr"
                    ? _c("span", { staticClass: "more_bets" }, [
                        _vm._v(_vm._s(_vm.$t("MarketsHeader.MoreBets")))
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33d54f0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33d54f0f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/big3MarketsHeader.vue
// module id = null
// module chunks = 